<template>
  <div class="mainClass">
    <!-- Buttons to trigger modals -->
    <div class="buttonGroup">
      <button type="button" class="btn btn-primary mb-2" data-bs-toggle="modal" data-bs-target="#studentRegistrationModal">
        Register Student
      </button>
      <button type="button" class="btn btn-secondary mb-2" data-bs-toggle="modal" data-bs-target="#addGradeModal">
        Add Grade
      </button>
      <button type="button" class="btn btn-secondary mb-2" data-bs-toggle="modal" data-bs-target="#addPaymentTypeModal">
        Add Payment Type
      </button>
    </div>

    <!-- Institute Registration Modal -->
    <div class="modal fade" id="studentRegistrationModal" tabindex="-1" aria-labelledby="studentRegistrationModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="studentRegistrationModalLabel">Student Registration</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <InsertStudent @studentAdded="fetchStudents"/>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Location Modal -->
    <div class="modal fade" id="addGradeModal" tabindex="-1" aria-labelledby="addGradeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="addGradeModalLabel">Add Grade</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <InsertGrade />
          </div>
        </div>
      </div>
    </div>

    <!-- Add PaymentType Modal -->
    <div class="modal fade" id="addPaymentTypeModal" tabindex="-1" aria-labelledby="addPaymentTypeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="addPaymentTypeModalLabel">Add Payment Type</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <InsertPaymentType />
          </div>
        </div>
      </div>
    </div>

    <!-- Institute Table -->
    <div class="container mt-4">
      <!-- Show total count -->
  <div class="mb-3">
    <strong>Total Students: </strong> {{ total }}
  </div>
  
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark">
            <tr>
              <th>ID</th>
              <th>Student Name</th>
              <th>Institute Name</th>
              <!-- <th>Teacher Name</th> -->
              <th>Contact</th>
              <th>Grade</th>
              <th>View</th>
              <th>More</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student.id">
              <td>{{ student.id }}</td>
              <td>{{ student.first_name }}</td>
              <td>{{ student.institute.institute_name }}</td>
              <!-- <td>{{ student.teacher.user.first_name }}</td> -->
              <td>{{ student.contact }}</td>
              <td>{{ student.grade.grade_level }}</td>

              <td>
                <button @click="viewStudentDetails(student.id)" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#showStudentModal">
                  <i class="bi bi-eye"></i> View
                </button>
              </td>

              <td>
                  <button @click="moreStudentDetails(student.id , student.institute_id)" class="btn btn-outline-primary btn-sm">
                    <i class="bi bi-three-dots"></i> More
                  </button>
                </td>

              <td>
                <button @click="editStudentDetails(student.id)" class="btn btn-outline-warning btn-sm" data-bs-toggle="modal" data-bs-target="#editStudentModal">
                  <i class="bi bi-pencil"></i> Edit
                </button>
              </td>
              <td>
                <button @click="deleteStudent(student.id)" class="btn btn-outline-danger btn-sm">
                  <i class="bi bi-trash"></i> Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <nav v-if="lastPage > 1" class="mt-3 d-flex justify-content-center">
  <ul class="pagination">
    <li class="page-item" :class="{ disabled: currentPage === 1 }">
      <button class="page-link" @click="changePage(currentPage - 1)">Previous</button>
    </li>

    <li
      v-for="page in lastPage"
      :key="page"
      class="page-item"
      :class="{ active: page === currentPage }"
    >
      <button class="page-link" @click="changePage(page)">{{ page }}</button>
    </li>

    <li class="page-item" :class="{ disabled: currentPage === lastPage }">
      <button class="page-link" @click="changePage(currentPage + 1)">Next</button>
    </li>
  </ul>
</nav>


        <!-- Loading Spinner -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- No Data Found Message -->
    <div v-else-if="students.length === 0" class="text-center my-4">
      <p class="text-muted fs-5">No data found</p>
    </div>
      </div>
    </div>


    <!-- Modal View -->
    <div class="modal fade" id="showStudentModal" tabindex="-1" aria-labelledby="showStudentModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="showStudentModalLabel">Student Details</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <ViewStudent :student="selectedStudent" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Edit -->
    <div class="modal fade" id="editStudentModal" tabindex="-1" aria-labelledby="editStudentModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="editStudentModalLabel">Edit Student</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <EditStudent :student="selectedStudentEdit"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import InsertStudent from '@/components/Student/InsertStudent.vue';
import ViewStudent from '@/components/Student/ViewStudent.vue';
import EditStudent from '@/components/Student/EditStudent.vue';
import InsertGrade from '@/components/Student/InsertGrade.vue';
import InsertPaymentType from '../Student/InsertPaymentType.vue';

export default {
  name: 'InstituteTable',
  components: {
    InsertStudent,
    ViewStudent,
    EditStudent,
    InsertGrade,
    InsertPaymentType,
  },
  data() {
    return {
      loading: true, // Initial state
      students: [],
      currentPage: 1,
    lastPage: 1,
    total: 0,
      selectedStudent: null, // Store the selected institute details here
      selectedStudentEdit: null,
    };
  },
  mounted() {
    this.fetchStudents();
    
  },
  methods: {
    // async fetchStudents() {
    //   this.loading = true;
    //   try {
    //     const response = await axios.get('/get-students');
    //     this.students = response.data;
    //   } catch (error) {
    //     console.error('Error fetching students:', error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    async fetchStudents(page = 1) {
  this.loading = true;
  try {
    const response = await axios.get(`/get-students?page=${page}`);
    this.students = response.data.data; // paginated data
    this.currentPage = response.data.current_page;
    this.lastPage = response.data.last_page;
    this.total = response.data.total;
  } catch (error) {
    console.error('Error fetching students:', error);
  } finally {
    this.loading = false;
  }
},
changePage(page) {
    if (page >= 1 && page <= this.lastPage) {
      this.fetchStudents(page);
    }
  },

    async viewStudentDetails(id) {
      try {
        const response = await axios.get(`/get-student-by-id/${id}`);
        this.selectedStudent = response.data;
      } catch (error) {
        console.error('Error fetching student details:', error);
        this.selectedStudent = null;
      }
    },
    
    moreStudentDetails(id , institute_id) {
      // Navigate to the more details page using query parameters
      this.$router.push({ name: 'MoreStudentDetails', query: { studentId: id, instituteId: institute_id } });
    },


    async editStudentDetails(id) {
      try {
        const response = await axios.get(`/get-student-by-id/${id}`);
        this.selectedStudentEdit = response.data;
      } catch (error) {
        console.error('Error fetching student details for edit:', error);
        this.selectedStudentEdit = null;
      }
    },

    async deleteStudent(id) {
      try {
        await axios.delete(`/delete-student/${id}`);
        this.students = this.students.filter(student => student.id !== id);
        alert('Student deleted successfully');
      } catch (error) {
        console.error('Error deleting student:', error);
        alert('Failed to delete student');
      }
    },
    
  },
};
</script>

<style scoped>
.mainClass {
  width: 100%;
  height: 100%;
}
.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}
.buttonGroup {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
}
.table-responsive {
  max-width: 100%;
  overflow-x: auto;
}
@media (max-width: 768px) {
  .modal-dialog-centered {
    max-width: 100%;
    margin: 0;
  }
  .buttonGroup {
    width: 100%;
    height: 100%;
    display: inline-block;
    align-items: center;
    justify-content: center;
    padding: 10px 50px;
  }
  .btn {
    width: 100%;
    margin-bottom: 5px;
  }
  .modal-content {
    padding: 10px;
  }
  .table-responsive {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-x: scroll;
    max-width: 75svw;
  }
}
</style>
